import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { AuthServiceError } from '@personal-area/global/authorization/models';
import {
  IS_API_GATEWAY,
  IS_PRIVATE_API,
} from '@personal-area/global/http/models';

import { PhoneCancelCheck, PhoneCheck } from '../models/phone-check';
import { PhoneHash } from '../models/phone-hash';
import { PhoneRequest, VerificationType } from '../models/phone-request';

const phoneURLs = {
  requestCode: '/v1/phone-verification/request-code',
  checkCode: '/v1/phone-verification/check-code',
  cancelPhone: '/v1/phone-verification/cancel',
  checkCancelCode: '/v1/phone-verification/check-cancel-code',
};

export const PhoneServiceErrorCodes = [
  340001,
  AuthServiceError.InvalidSocialResponse,
  31002,
];

@Injectable()
export class PhoneService {
  constructor(private _http: HttpClient) {}

  /**
   * Basic user registration.
   * @param {PhoneRequest} data данные запроса
   * @return {Observable<PhoneHash>} hash код для проверки
   */
  public requestCode(data: PhoneRequest): Observable<PhoneHash> {
    return this._http.post<PhoneHash>(phoneURLs.requestCode, data, {
      context: new HttpContext()
        .set(IS_PRIVATE_API, true)
        .set(IS_API_GATEWAY, true),
    });
  }

  public checkCode(data: PhoneCheck): Observable<void> {
    return this._http.post<void>(phoneURLs.checkCode, data, {
      context: new HttpContext()
        .set(IS_PRIVATE_API, true)
        .set(IS_API_GATEWAY, true),
    });
  }

  public cancelPhone(type = VerificationType.Sms): Observable<PhoneHash> {
    return this._http.post<PhoneHash>(
      phoneURLs.cancelPhone,
      { type: type },
      {
        context: new HttpContext()
          .set(IS_PRIVATE_API, true)
          .set(IS_API_GATEWAY, true),
      },
    );
  }

  public checkCancelCode(data: PhoneCancelCheck): Observable<void> {
    return this._http.post<void>(phoneURLs.checkCancelCode, data, {
      context: new HttpContext()
        .set(IS_PRIVATE_API, true)
        .set(IS_API_GATEWAY, true),
    });
  }
}
